interface IFilterOption {
    field: string
    operator: 'match' | 'contains' | 'excludes' | 'startsWith' | 'endsWith'
    value: any
}

type FilterOptionFunc = (data: any) => IFilterOption[]

export interface IFilter {
    type: 'and' | 'or'
    options: FilterOptionFunc | IFilterOption[]
}

class Filter {
    filterObj: IFilter
    data: any

    constructor(filter: IFilter, data) {
        this.filterObj = filter
        this.data = data
    }

    match = () => {}

    filter = (data) => {
        const _data = []
        const { type, options } = this.filterObj
        const _options = typeof options === 'function' ? options(data) : options

        data.forEach((dataItem) => {
            let isMatch = false
            let stop = false

            _options.forEach((filterOpt) => {
                if (stop) {
                    return
                }
                const { field, operator, value } = filterOpt
                const dataItemValue = dataItem[field]

                if (operator === 'match') {
                    if (dataItemValue === value) {
                        isMatch = true
                    } else {
                        if (type === 'and') {
                            isMatch = false
                            stop = true
                        }
                    }
                }
            })

            if (isMatch) {
                _data.push(dataItem)
            }
        })

        return _data
    }
}

export default Filter
